/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Clear_MessageInputs */

const en_confirm_clear_message = /** @type {(inputs: Confirm_Clear_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to clear all input and output?`)
};

const ko_confirm_clear_message = /** @type {(inputs: Confirm_Clear_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입력과 출력을 모두 초기화하시겠습니까?`)
};

const ja_confirm_clear_message = /** @type {(inputs: Confirm_Clear_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力と出力をすべてクリアしますか？`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to clear all input and output?" |
*
* @param {Confirm_Clear_MessageInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const confirm_clear_message = /** @type {((inputs?: Confirm_Clear_MessageInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Clear_MessageInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_clear_message(inputs)
	if (locale === "ko") return ko_confirm_clear_message(inputs)
	return ja_confirm_clear_message(inputs)
});